const merge2Canvases = (invertLayer?: boolean): string | undefined => {
  const freshCanvas: HTMLCanvasElement = document.createElement("canvas");
  const baseCanvas = document.getElementById("sketchContainer")!.firstChild!
    .firstChild! as HTMLCanvasElement;

  const threeJSCanvas = document.getElementById(
    "threeCanvasEl"
  ) as HTMLCanvasElement;

  if (baseCanvas && threeJSCanvas) {
    freshCanvas.width = threeJSCanvas.width;
    freshCanvas.height = threeJSCanvas.height;

    const primaryCanvasContext = freshCanvas.getContext("2d");
    if (primaryCanvasContext) {
      primaryCanvasContext.fillStyle = "white";
      primaryCanvasContext.fillRect(0, 0, threeJSCanvas.width, threeJSCanvas.height);
      if (invertLayer) {
        primaryCanvasContext.drawImage(threeJSCanvas, 0, 0);
        primaryCanvasContext.drawImage(baseCanvas, 0, 0);
      } else {
        primaryCanvasContext.drawImage(baseCanvas, 0, 0,threeJSCanvas.width,threeJSCanvas.height);
        primaryCanvasContext.drawImage(threeJSCanvas, 0, 0,threeJSCanvas.width,threeJSCanvas.height);
      }

      return freshCanvas.toDataURL(".png", 1);
    } else {
      return undefined;
    }
  }
  return undefined;
};

export default merge2Canvases;
